import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Formik } from 'formik';
import { AppDatePicker } from '@/layout/AppComponents';
import Moment from 'moment';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { createPortal } from 'react-dom';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';

const LastVerification = (props) => {
  const { date } = props;
  const dispatch = useDispatch();
  const isSidebarOpened = useSelector((state) => state.auth?.settings?.preferences?.sidebar?.isOpened);
  const lastVerification = useSelector((state) => state.currentPage?.options?.lastVerification);
  const { moduleBridgeHex, plantHex } = useParams();

  // > UPDATE LASTVERIFICATION
  const handleUpdateLastVerification = async (values) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_changeLastVerification"
        ),
        { moduleBridgeHex, plantHex, date: values.date }
      );
      return response.data;
    } catch (err) {}
  };
  // < UPDATE LASTVERIFICATION
  if (lastVerification === undefined) return <></>;
  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize
      initialValues={{
        date: lastVerification,
      }}
      onSubmit={(v) => handleUpdateLastVerification(v)}
    >
      {({
        setFieldValue, handleSubmit, values,
      }) => (
        <>
          {isSidebarOpened ? (
            <AppDatePicker
              title={<Translator file="user" name="user.lg.last-modification-stamp" />}
              value={values.date}
              onChange={(opt) => { setFieldValue('date', opt); handleSubmit(); }}
              placeholder="dd/mm/yyyy"
              popperClassName="react-datepicker-popper-100"
              popperContainer={({ children }) => createPortal(children, document.body)}
              isClearable
            />
          ) : (
            <DatePicker
              locale="en"
              selected={values.date && Moment(values.date, 'DD/MM/YYYY').toDate()}
              // dateFormat="dd/MM/yyyy"
              onChange={(opt) => { setFieldValue('date', opt && Moment(opt).format('DD/MM/YYYY')); handleSubmit(); }}
              showMonthDropdown
              showYearDropdown
              popperClassName="react-datepicker-popper-100"
              popperContainer={({ children }) => createPortal(children, document.body)}
              customInput={(
                <NoSidebarDate className="pointer">
                  {values.date ? (
                    <>
                      { Moment(values.date, 'DD/MM/YYYY').format('DD/MM')}
                      <br />
                      { Moment(values.date, 'DD/MM/YYYY').format('YYYY')}
                    </>
                  ) : (
                    <>
                      dd/mm
                      <br />
                      yyyy
                    </>
                  )}

                </NoSidebarDate>
                      )}
            />

          )}
        </>
      )}
    </Formik>
  );
};
export default LastVerification;

const NoSidebarDate = styled.div`
  font-size: 12px;
  width: 44px;
  color: ${colors.primary};
  text-align: center;
`;
